export default __webpack_public_path__ + "static/media/2-horizontalBtn.b3ace798.jpg";